define(['jquery'], function($){
	"use strict";

	var PLUGIN_NAME = "rowHeight";
	var PLUGIN_VERSION = "v1";

	var DEFAULTS = {
		selector : '',
		item : ''
	};

	// The actual plugin constructor
	var RowHeight = function ( element, options ) {
		this.element = element;
		this.$t = $(this.element);

		this.options = $.extend(true, {}, DEFAULTS, options );
		this._defaults = DEFAULTS;
		this.initialise();
	};

	/**
	 * init function
	 */
	RowHeight.prototype.initialise = function() {

		this.containerWidth = 0;
		this.elementWidth = 0;
		this.elementWidth2 = 0;
		this.linesCount = 0;
		this.columnCount = 0;
		this.elementCount = 0;
		this.actHeight = 0;

		this.setRowHeight();
		this.bindEvents();

		this.resizeTimer = null;
	};

	RowHeight.prototype.setRowHeight = function() {
		var o = this.options;
		//var self = this;

		this.containerWidth = this.$t.width();
		if (this.containerWidth == 0) {
			return false;
		}
		this.elementCount = $(o.selector, this.$t).size();
		this.elementWidth = $(o.selector, this.$t).first().outerWidth(true);
		this.columnCount = Math.round(this.containerWidth/this.elementWidth);
		this.linesCount = Math.ceil(this.elementCount/this.columnCount);

		if($(o.item, this.$t).size() > 0) {
			this.setHeight(o.item);
		}
		this.setHeight(o.selector);

	};

	RowHeight.prototype.setHeight =  function(selector) {
		var self = this;
		$(selector, this.$t).css('height','auto');
		for (var i = 0; i < this.linesCount; i++) {
			this.actHeight = 0;

			for (var j = i*this.columnCount; j < i*this.columnCount+this.columnCount; j++) {
				this.actHeight = ($(selector + ':eq('+j+')', this.$t).outerHeight() > this.actHeight) ? $(selector + ':eq('+j+')', this.$t).outerHeight() : this.actHeight;
			}
			$(selector, this.$t).filter(function(index){
				return index >= i*self.columnCount && index < i*self.columnCount+self.columnCount;
			}).outerHeight(self.actHeight);
		}
	};


	RowHeight.prototype.bindEvents =  function() {
		var self = this;

		$(window).bind('resize.rowheightChange', function() {
			clearTimeout(self.resizeTimer);
			self.resizeTimer = setTimeout(function() {
				self.setRowHeight();
			}, 200);
		});

	};

	/**
	 * decide, which methods will be "public"
	 */
	var API = {
		setRowHeight: RowHeight.prototype.setRowHeight
	};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 * 		if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);
			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new RowHeight(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);

			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};


	/**
	 * setDefaults with $.googlemap.setDefaults();
	 */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function(newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};

});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.rowHeight.js